import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=5fb50e47&scoped=true&"
import script from "./Refund.vue?vue&type=script&lang=js&"
export * from "./Refund.vue?vue&type=script&lang=js&"
import style0 from "./Refund.vue?vue&type=style&index=0&id=5fb50e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb50e47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCol,VRow,VSimpleTable})
